<template lang="pug">
.benchmarks-basics
  h5.benchmarks-heading Activity measures how active users are on their mouse and keyboard.

  .basics-stats
    .basics-stats-item
      .basics-stats-pill.benchmarks-pill.high 51-100%
      p You're in the zone. Way to go!
    .basics-stats-item
      .basics-stats-pill.benchmarks-pill.medium 21-50%
      p Depending on the work, this is a good range to be in.
    .basics-stats-item
      .basics-stats-pill.benchmarks-pill.low 0-20%
      p You're not very active on the computer.
    .basics-stats-item
      .basics-stats-pill.benchmarks-pill.idle Idle
      div
        p You weren't touching the mouse or keyboard at all.
        p
          a(:href="tabData.organization_members_url") Idle settings
          |
          | can be customized for each team member.

  .basics-video
    h5.benchmarks-heading Welcome to activity video
    span(
      :class="`wistia_embed wistia_async_${video} popover=true popoverAnimateThumbnail=false`"
      style="display: inline-block; height: 85px; width: 150px"
    )
</template>

<script>
export default {
  name: 'ActivitiesBenchmarksDialogBasics',
  props: {
    tabData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    // See: https://hubstaff.wistia.com/medias/gcd57zm667
    video: Object.freeze('gcd57zm667'),
  }),
  created() {
    /**
     * Make this non-reactive by attaching the data property
     * after the observation phase has finsihed.
     */
    this.__scripts = [];
    // Create the scripts and append them to the head
    this.createWistiaScripts();
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    createWistiaScripts() {
      const scripts = [
        Object.assign(document.createElement('script'), {
          async: '',
          src: `//fast.wistia.com/embed/medias/${this.video}.jsonp`,
        }),
        Object.assign(document.createElement('script'), {
          async: '',
          src: '//fast.wistia.com/assets/external/E-v1.js',
        }),
      ];

      // Keep track of the created scripts to clean up before
      // destroying the component.
      this.__scripts.push(...scripts);

      // We have to append them in the head as doing so in the
      // template is not allowed.
      scripts.forEach((script) => {
        document.head.appendChild(script);
      });
    },
    cleanup() {
      if (this.__scripts && this.__scripts.length) {
        this.__scripts.forEach((script) => {
          if (document.head.contains(script)) {
            document.head.removeChild(script);
          }
        });
      }
    },
  },
};
</script>
